import { Typography } from '@remarkable/ark-web';
import type { FleetDevice } from 'src/api/endpoints/cloudEnterprise.types';
import { DeviceName } from 'src/components/DeviceName';

export function CellDevice({ device }: { device: FleetDevice }) {
  return (
    <div className="w-full">
      <Typography variant="interface-sm" className="truncate">
        <DeviceName device={device} />
      </Typography>
      <Typography
        variant="interface-xs"
        className="mt-6 truncate text-text-muted"
      >
        {device.serialNumber}
      </Typography>
    </div>
  );
}
